import React from "react"
import PropTypes from "prop-types"
import styles from "@/components/CustomComponents/PromoCollection/index.module.scss"
import { useDeviceType } from "@/hooks/useDeviceType"
import DesktopSection from "@/components/CustomComponents/PromoCollection/DesktopSection"
import MobileSection from "@/components/CustomComponents/PromoCollection/MobileSection"

const PromoCollection = props => {
  const { collectionItems } = props
  const { isMobile, width } = useDeviceType()
  return (
    <div className={styles.wrapper}>
      <div className=" koh-desktop-row border-b border-[#e8e8e8] pb-10 lg:mx-0  w-full min-h-full">
        {isMobile ? (
          <MobileSection collectionItems={collectionItems} />
        ) : (
          <DesktopSection collectionItems={collectionItems} />
        )}
      </div>
    </div>
  )
}

PromoCollection.propTypes = {
  collectionItems: PropTypes.object,
}

PromoCollection.defaultProps = {
  collectionItems: {},
}

export default PromoCollection
